/**
 * App Root Component
 * Falcon Terminal - Single Page Application
 * Houses Falcon Analysis, Falcon Innovation Studio, and Strategy Studio
 */

import React from "react";

import { AppProviders } from "./providers";
import { AppRouter } from "./routes/AppRouter";

export const App: React.FC = () => {
  return (
    <AppProviders>
      <AppRouter />
    </AppProviders>
  );
};

export default App;
